import request from "@/libs/request";
import {
  CreateProjectGroupsRequest,
  CreateProjectGroupsResponse,
  DeleteProjectGroupsFilesRequest,
  DeleteProjectGroupsFilesResponse,
  DeleteProjectGroupsResponse,
  DownloadProjectGroupsFilesRequest,
  DownloadProjectGroupsFilesResponse,
  InviteProjectGroupsMembersRequest,
  InviteProjectGroupsMembersResponse,
  ReadProjectGroupsAllRequest,
  ReadProjectGroupsAllResponse,
  ReadProjectGroupsByTaskIdRequest,
  ReadProjectGroupsByTaskIdResponse,
  ReadProjectGroupsResponse,
  ReadProjectGroupsTasksAllRequest,
  ReadProjectGroupsTasksAllResponse,
  RemoveProjectGroupsMembersRequest,
  RemoveProjectGroupsMembersResponse,
  SaveProjectGroupsBidNoticeRequest,
  SaveProjectGroupsBidNoticeResponse,
  SearchProjectGroupsBidNoticeRequest,
  SearchProjectGroupsBidNoticeResponse,
  UpdateProjectGroupsRequest,
  UpdateProjectGroupsResponse,
  UploadProjectGroupsFilesRequest,
  UploadProjectGroupsFilesResponse,
} from "@/types/project";

// 전체 프로젝트 그룹 조회
export const readProjectGroupsAll = async ({
  data,
}: {
  data: ReadProjectGroupsAllRequest;
}): Promise<ReadProjectGroupsAllResponse> => {
  const response = await request.post<ReadProjectGroupsAllResponse>(
    `/project-groups/read`,
    data
  );
  return response.data;
};

// 전체 프로젝트 작업 목록 조회
export const readProjectGroupsTasksAll = async ({
  data,
}: {
  data: ReadProjectGroupsTasksAllRequest;
}): Promise<ReadProjectGroupsTasksAllResponse> => {
  const response = await request.post<ReadProjectGroupsTasksAllResponse>(
    `/project-groups/read-tasks`,
    data
  );
  return response.data;
};

// 작업 ID로 프로젝트 그룹 조회
export const readProjectGroupsByTaskId = async ({
  task_id,
}: ReadProjectGroupsByTaskIdRequest): Promise<ReadProjectGroupsByTaskIdResponse> => {
  const response = await request.post<ReadProjectGroupsByTaskIdResponse>(
    `/project-groups/read-by-task`,
    { task_id }
  );
  return response.data;
};

// 프로젝트 그룹 생성
export const createProjectGroups = async ({
  data,
}: {
  data: CreateProjectGroupsRequest;
}): Promise<CreateProjectGroupsResponse> => {
  const response = await request.post<CreateProjectGroupsResponse>(
    `/project-groups/create`,
    data
  );
  return response.data;
};

// 단일 프로젝트 그룹 조회
export const readProjectGroups = async ({
  group_id,
}: {
  group_id: string;
}): Promise<ReadProjectGroupsResponse> => {
  const response = await request.post<ReadProjectGroupsResponse>(
    `/project-groups/${group_id}/read`
  );
  return response.data;
};

// 프로젝트 그룹 정보 수정
export const updateProjectGroups = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: UpdateProjectGroupsRequest;
}): Promise<UpdateProjectGroupsResponse> => {
  const response = await request.post<UpdateProjectGroupsResponse>(
    `/project-groups/${group_id}/update`,
    data
  );
  return response.data;
};

// 프로젝트 그룹 삭제
export const deleteProjectGroups = async ({
  group_id,
}: {
  group_id: string;
}): Promise<DeleteProjectGroupsResponse> => {
  const response = await request.post<DeleteProjectGroupsResponse>(
    `/project-groups/${group_id}/delete`
  );
  return response.data;
};

// 프로젝트 그룹 참여자 초대
export const inviteProjectGroupsMembers = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: InviteProjectGroupsMembersRequest;
}): Promise<InviteProjectGroupsMembersResponse> => {
  const response = await request.post<InviteProjectGroupsMembersResponse>(
    `/project-groups/${group_id}/invite-members`,
    data
  );
  return response.data;
};

// 프로젝트 그룹 참여자 제거
export const removeProjectGroupsMembers = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: RemoveProjectGroupsMembersRequest;
}): Promise<RemoveProjectGroupsMembersResponse> => {
  const response = await request.post<RemoveProjectGroupsMembersResponse>(
    `/project-groups/${group_id}/remove-members`,
    data
  );
  return response.data;
};

// 프로젝트 그룹 파일 업로드
export const uploadProjectGroupsFiles = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: UploadProjectGroupsFilesRequest;
}): Promise<UploadProjectGroupsFilesResponse> => {
  const response = await request.post<UploadProjectGroupsFilesResponse>(
    `/project-groups/${group_id}/upload-files`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

// 프로젝트 그룹 파일 다운로드
export const downloadProjectGroupsFiles = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: DownloadProjectGroupsFilesRequest;
}): Promise<DownloadProjectGroupsFilesResponse> => {
  const response = await request.post<DownloadProjectGroupsFilesResponse>(
    `/project-groups/${group_id}/download-files`,
    data
  );
  return response.data;
};

// 프로젝트 그룹 파일 삭제
export const deleteProjectGroupsFiles = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: DeleteProjectGroupsFilesRequest;
}): Promise<DeleteProjectGroupsFilesResponse> => {
  const response = await request.post<DeleteProjectGroupsFilesResponse>(
    `/project-groups/${group_id}/delete-files`,
    data
  );
  return response.data;
};

// 프로젝트 그룹 공고 검색
export const searchProjectGroupsBidNotice = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: SearchProjectGroupsBidNoticeRequest;
}): Promise<SearchProjectGroupsBidNoticeResponse> => {
  const response = await request.post<SearchProjectGroupsBidNoticeResponse>(
    `/project-groups/${group_id}/search-project`,
    data
  );
  return response.data;
};

// 프로젝트 그룹 공고 저장
export const saveProjectGroupsBidNotice = async ({
  group_id,
  data,
}: {
  group_id: string;
  data: SaveProjectGroupsBidNoticeRequest;
}): Promise<SaveProjectGroupsBidNoticeResponse> => {
  const response = await request.post<SaveProjectGroupsBidNoticeResponse>(
    `/project-groups/${group_id}/save-project`,
    data
  );
  return response.data;
};
